module.exports = __webpack_public_path__ + "images/background_pattern.4321ce2de5.jpg";